import View from './view'
import sorting from '../sort'

/**
 * Abstract class
 */
export default class PropertyLister {

    /**
     *
     * @param {Finder} finder Finder app
     */
    constructor(finder) {
        this.finderInstance = finder
        this.view = new View(this)

        this.title = 'Fastigheter lista: '
        this.titleRoot = ''

        this.props = {
            objekts: [],
            projekts: [],
            areas: []
        }

        this.sortMethod = sorting.defaultOption

        this.objektsPagination = {
            showOnScreen: 0,
            perScreen: 24,
            moreButton: '',
        }

        this.activeTab = 'projekts'


        //--- DEFINE PROPERTY PROPERTIES ---//
        this.objektProps = []
        this.objektProps.push({
            name: 'Status',
            sortingMethod: sorting.options.status,
            getValueFormProperty: property => property.props.status,
        })
        this.objektProps.push({
            name: 'Namn',
            sortingMethod: sorting.options.namn,
            getValueFormProperty: property => property.name,
        })
        this.objektProps.push({
            name: 'Våning',
            sortingMethod: sorting.options.vaning,
            getValueFormProperty: property => property.props.floor,
        })
        this.objektProps.push({
            name: 'Yta',
            sortingMethod: sorting.options.area,
            getValueFormProperty: property => property.props.area + ' kvm',
        })
        this.objektProps.push({
            name: 'Pris',
            sortingMethod: sorting.options.price,
            getValueFormProperty: property => {
                if (property.props.price_overwrite) {
                    return property.props.price_overwrite;
                } else {
                    return /bokad|s[aå]ld/i.test(property.props.status) ? "–" : Number.parseInt(property.props.price)
                        .toLocaleString("sv-SE") + " kr";
                }
            },
        })
        this.objektProps.push({
            name: 'Avgift',
            sortingMethod: sorting.options.avgift,
            getValueFormProperty: property => {
                return /bokad|s[aå]ld/i.test(property.props.status) ? '–' : Number.parseInt(property.props.fee)
                    .toLocaleString('sv-SE') + ' kr'
            },
        })
        this.objektProps.push({
            name: 'Rum',
            sortingMethod: sorting.options.rum,
            getValueFormProperty: property => property.props.rooms + ' rok',
        })
        this.objektProps.push({
            name: 'Preliminär inflyttning',
            sortingMethod: sorting.options.inflyttning,
            getValueFormProperty: property => property.props.salesText,
        })

        this.projektProps = []
        this.projektProps.push({
            name: 'Namn',
            sortingMethod: sorting.options.namn,
            getValueFormProperty: property => property.name,
        })
        this.projektProps.push({
            name: 'Status',
            sortingMethod: sorting.options.status,
            getValueFormProperty: property => property.props.status,
        })
        this.projektProps.push({
            name: 'Prisspann',
            sortingMethod: sorting.options.price,
            getValueFormProperty: property => {
                return /sluts[aå]lt/i.test(property.props.status) ? '–' : `${Number.parseInt(property.props.minPrice)
                    .toLocaleString('sv-SE')} – ${Number.parseInt(property.props.maxPrice).toLocaleString('sv-SE')} kr`
            },
        })
        this.projektProps.push({
            name: 'Avgift',
            sortingMethod: sorting.options.avgift,
            getValueFormProperty: property => {
                return /sluts[aå]lt/i.test(property.props.status) ? '–' : `${Number.parseInt(property.props.minFee)
                    .toLocaleString('sv-SE')} – ${Number.parseInt(property.props.maxFee).toLocaleString('sv-SE')} kr`
            },
        })
        this.projektProps.push({
            name: 'Lägenhetsspann',
            sortingMethod: sorting.options.rum,
            getValueFormProperty: property => `${property.props.minRooms} – ${property.props.maxRooms} rok`,
        })
        this.projektProps.push({
            name: 'Preliminär inflyttning',
            sortingMethod: sorting.options.inflyttning,
            getValueFormProperty: property => property.props.salesText,
        })
    }

    /**
     * Reset accumulated object properties
     * @returns {Object} this Class instance
     */
    reset() {
        this.props.objekts = []
        this.props.projekts = []
        this.props.areas = []

        this.objektsPagination.moreButton = ''
        this.objektsPagination.store = []
        return this
    }

    fillTitle() {
        this.titleRoot = this.view.propTitle()
        return this
    }

    setSortingMethod(sortMethod) {
        // console.log("Setting sorting method to:", sortMethod.name);
        this.sortMethod = sortMethod
        return this
    }

    sortProps() {
        // console.log("Sorting props with:", this.sortMethod);
        this.props = this.sortMethod.execute(this.props)
        return this
    }

    setActiveTab(name = 'projekts') {
        if (typeof name !== 'string') {
            return this
        }

        this.finderInstance.contentRoot.get(0).className
            = this.finderInstance.contentRoot.get(0)
            .className.replace(/(\s)?ptab-[^\s]+/i, '')

        this.finderInstance.contentRoot.addClass(`ptab-${name}`)
        this.activeTab = name
        return this
    }


    /**
     * Controller method for this class that implements it
     * @param {Object} data Projekts and Objekts raw data
     * @returns {Object} this Class instance
     */
    manage(data) {
        throw new Error('\'manage\' method not implemented')
    }

    /**
     * Returns rendered HTML string
     * @returns {String} HTML markup
     */
    render() {
        throw new Error('\'render\' method not implemented')
    }
}

